import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Box, Center, Flex, HStack, Image, Link, Spacer} from '@chakra-ui/react';
import styled, {css} from 'styled-components';

import background from '../../assets/images/background2.png';
import Logo from '../../assets/logos/logo_120x120.png';
import profile1 from '../../assets/images/profile-landing-1.png';
import profile2 from '../../assets/images/profile-landing-2.png';
import profile3 from '../../assets/images/profile-landing-3.png';
import {H1, H2, H3, TextG14} from '../typography';
import {getAppName} from '../../utils/app';

const StyledBox = styled(Box)`
  background-repeat: no-repeat !important;
  background-size: cover !important;
  /* Fill the viewport and lay the page out as a column: a pinned header on top
     and a flex-growing body that vertically centers its content. On tall
     screens the extra space is distributed above and below (centered, like
     production); on short screens the body collapses so everything still fits.
     If a device is shorter than the content, it falls back to document scroll
     instead of clipping. 100dvh accounts for mobile browser chrome; 100vh is
     the fallback for older WebViews. */
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  ${(props) =>
    props.bg &&
    css`
      background: linear-gradient(0deg, #272929 -3.94%, rgba(39, 41, 41, 0) 108.19%),
        url(${background});
    `};
`;

interface LandingWrapperProps {
  title: string;
  subtitle: string;
  numOfRegistered: number;
  children: React.ReactNode;
  additionalTitleLine?: string;
}

function LandingWrapper({
  children,
  title,
  subtitle,
  numOfRegistered,
  additionalTitleLine,
}: LandingWrapperProps) {
  const navigate = useNavigate();

  return (
    <StyledBox bg={background}>
      <Flex px={6} pt={6} pb={2} alignItems="center" flexShrink={0}>
        <Box>
          <Link href="https://walkabout.app">
            <H2 color={'white'}>{getAppName()}</H2>
          </Link>
        </Box>
        <Spacer />
        <Box>
          <Image src={Logo} width="42px" alt="Logo" onClick={() => navigate('/login')} />
        </Box>
      </Flex>
      <Flex flex="1" direction="column" justifyContent="center" py={2}>
        <Center>
          <H1 color="white" textAlign={'center'}>
            {title}
          </H1>
        </Center>
        {additionalTitleLine && (
          <Center mt="-30px" mb="10px">
            <H3 color="white" textAlign={'center'} fontStyle="italic">
              {additionalTitleLine}
            </H3>
          </Center>
        )}
        <TextG14 py={2} color={'white'} textAlign={'center'} px="56px">
          {subtitle}
        </TextG14>
        <Center>
          <HStack mt={3}>
            <Box display="inline-flex">
              <Image src={profile1} alt="Profile 1" />
              <Image ml="-26px" src={profile2} alt="Profile 2" />
              <Image ml="-26px" src={profile3} alt="Profile 3" />
            </Box>
            <TextG14 color={'white'} textAlign={'center'}>{`+${
              numOfRegistered || 0
            } locals like you`}</TextG14>
          </HStack>
        </Center>
        {children}
      </Flex>
    </StyledBox>
  );
}

export default LandingWrapper;
